export enum WebshopAttribute {
    Static = 'data-static',
}
